import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ITransport, IDocument, IDelegation } from "dataModels/contract";
import "views/contractView/styles/contractDataStyles.css";
import "views/contractView/styles/transportDataStyles.css";
import { useDispatch, useSelector } from "react-redux";
import {
    requestPending,
    requestPristine,
} from "state/reducer/requestStatusSlice";
import {
    getTransport,
    changeStatus,
    deleteDelegationAPI,
    deleteEntity,
    enableDisableDelegationAPI,
} from "net/contracts";
import { Textlink, ActionButton, Button, Output, Table } from "@ds/ds-snam/react";
import {
    BadgeStatus,
    RoutePath,
    EntityType,
    DocumentType,
    UICommand,
    IAppUserProfile,
    DsLayout,
    ResponseStatus,
    ResponseCode,
    AppUserRole,
} from "shared/constants";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import { DATE_FORMAT } from "shared/constants";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { downloadInfo, downloadDocument } from "net/contracts";
import { saveAs } from "file-saver";
import transportIcon from "shared/assets/icons/Trasportatori.svg";
import {
    showNotification,
    hideNotification,
} from "state/reducer/notificationSlice";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import ConfirmPopUp from "components/ConfirmPopUp";
import { useTranslation } from "react-i18next";
import DialogMessage from "components/DialogMessage";
import DsBadge from "components/DsBadge";
import useAppUser from "hooks/useAppUser";
import {
    getDelegationLegend,
    getTableRowsDelegations,
} from "../shared/listUtils";
import { RootState } from "state/appStore";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import TransportInfo from "./transportInfo";
import { Col, Row } from "react-grid-system";
import { ITableCell, ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple  } from "shared/utils/dsComponentUtils";
import { AppUser } from "ooAuth2/appUser";

const defaultDoc: IDocument = {
    type: "",
    name: "",
    size: 0,
    content: "",
    expire: null,
};
const defaultFormData: ITransport = {
    id: "",
    businessName: "", //nome azienda trasportarrice
    businessSecondName: "", //ragione sociale
    businessAddress: "", //indirizzo azienda trasportatrice
    businessStreetNumber: "", //civico
    businessPostalCode: "", //CAP
    businessCity: "", //Città azienda
    businessProvince: "", //provincia azienda
    businessState: "", //stato azienda
    vat: "", //partita iva
    firstName: "", //nome persona di contatto
    secondName: "",
    email: "",
    countryCode: "", //prefisso cellulare
    phone: "",
    documents: [defaultDoc],
    delegations: [
        {
            delegationId: "",
            transporterId: "",
            businessId: "",
            businessName: "",
            document: {
                type: "delegation",
                name: "delegaExample.pdf",
                size: 0,
                content: "",
                expire: 0,
                status: 0,
            },
            delegationAbilitation:false
        },
    ],
    status: 2,
};

const TransportData: React.FC = (): JSX.Element => {
    const { t } = useTranslation(["contract", "app"]);
    const { id } = useParams();
    const appUserProfile: IAppUserProfile | undefined = useAppUser()?.userProfile;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();

    const [transportData, setTransportData] =
        useState<ITransport>(defaultFormData);
    //eslint-disable-next-line
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    //const [transporterRejectedText,setTransporterRejectedText] = useState('')
    //let tempValueRejectedTransporter = '' //To change al posto di transporerRejectedTest
    const [viewRejectingTransporterModal, setViewRejectingTransporterModal] =
        useState<boolean>(false);
    const [viewRejectionPopup, setViewRejectionPopup] =
        useState<boolean>(false);
    //const [delegationRejectedText,setDelegationRejectedText] = useState('')
    //let tempValueRejectedDelegation = ''; //to change al posto di delegationRejectedText
    const [rejectingDelegationId, setRejectingDelegationId] =
        useState<string>("");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const layoutMode = useSelector((state: RootState) => {
        return state.dsLayout.mode;
    });
    const loadData = useCallback(() => {
        dispatch(requestPending());
        getTransport(id!)
            .then((response) => {
                const transportResponse = response.data;
                setTransportData(transportResponse);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
    }, [dispatch, id]);
    const getBadgeDelegations = (status: BadgeStatus, isSmall?: boolean) => {
        let notificationStatus = "";
        if (status === BadgeStatus.APPROVED) {
            notificationStatus = "confirm";
        } else if (status === BadgeStatus.TOAPPROVE) {
            notificationStatus = "warning";
        } else if (status === BadgeStatus.NOTAPPROVED) {
            notificationStatus = "error";
        }
        return (
            <ds-notification-badge
                notification-status={notificationStatus}
                badge-variant="default"
                badge-number="0"
                badge-aria-label="Badge aria label"
                is-small={isSmall ? "true" : "false"}
                background-color=""
            ></ds-notification-badge>
        );
    };
    const getBadgeDocuments = (status: BadgeStatus, isSmall?: boolean) => {
        let notificationStatus = "";
        if (status === BadgeStatus.EXPIRED) {
            notificationStatus = "error";
        } else if (status === BadgeStatus.TOAPPROVE) {
            notificationStatus = "confirm";
        }
        return (
            <ds-notification-badge
                notification-status={notificationStatus}
                badge-variant="default"
                badge-number="0"
                badge-aria-label="Badge aria label"
                is-small={isSmall ? "true" : "false"}
                background-color=""
            ></ds-notification-badge>
        );
    };
    useEffect(() => {
        if (id) loadData();
    }, [id, loadData]);

    const downloadTranportertInfo = () => {
        //downloadTransporterData(id!)
        downloadInfo(id!, EntityType.TRANSPORTER)
            .then((response) => {
                let file = new File(
                    [response.data],
                    "transporter_" + id! + ".pdf"
                );
                saveAs(file);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const downloadTransporterDocument = (documentType: DocumentType) => {
        //downloadTransporterDocument(id!, documentType)
        downloadDocument(id!, EntityType.TRANSPORTER, documentType)
            .then((response) => {
                let file = new File(
                    [response.data],
                    "transporter_" + documentType + "_" + id! + ".pdf"
                );
                saveAs(file);
            })
            .catch((error) => {
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: 'Error',
                    description: error.message,
                    status: 'error',
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                console.log(error);
            });
    };

    const showPopupError = ()=>{
        let popUpAction: INotificationAction;
        const popUpTitle:string = "Error";
        const popUpDescription:string = "Error downloading the document";
        const popUpStatus:NotificationsStatusType = "error";
        popUpAction = {
            show: true,
            title: popUpTitle,
            description: popUpDescription,
            status: popUpStatus,
            onClose: (event: Event) => {
                dispatch(hideNotification());
            }
        };
        dispatch(showNotification(popUpAction));
    }
    const downloadTransporterDelegation = (delegationId:string,documentType: DocumentType) => {
        //downloadTransporterDocument(id!, documentType)
        downloadDocument(delegationId, EntityType.TRANSPORTERDELEGATION, documentType)
            .then((response) => {
                if(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT){
                    showPopupError()
                }
                let file = new File(
                    [response.data],
                    "transporter_" + documentType + "_" + id! + ".pdf"
                );
                saveAs(file);
            })
            .catch((error) => {
                showPopupError();
                console.log(error);
            });
    };
    const deleteTransporter = useCallback(() => {
        const popupAction: INotificationAction = {
            show: true,
            title: t(`transporter.transporterData.successToast.title`), //"Trasportatore eliminato correttamente",
            description: t(
                `transporter.transporterData.successToast.description`
            ), //"Il profilo del trasportatore è eliminato correttamente in piattaforma",//t(`customer.customerForm.successToast.${translationField}.subTitle`),
            status: "confirm",
            onClose: (event: Event) => {
                dispatch(hideNotification());
            },
        };

        dispatch(requestPending());
        deleteEntity(id!, EntityType.TRANSPORTER)
            .then((response) => {
                dispatch(showNotification(popupAction));
                navigate(RoutePath.CONTRACTS_TRANSPORTATORS_INFO);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
    }, [id, dispatch, navigate, t]);

    
    interface ChangeStatusOptions {
        id: string;
        entityType: EntityType;
        badgeStatus: BadgeStatus;
        message?: string;
        titleKey: string;
        descriptionKey: string;
        onSuccess?: () => void;
        onFinally?: () => void;
        responsePath?: "data" | ""; // specifica se la risposta è in response.data o direttamente in response
    }
    
    const handleChangeStatus = ({
        id,
        entityType,
        badgeStatus,
        message = "",
        titleKey,
        descriptionKey,
        onSuccess,
        onFinally,
        responsePath = "",
    }: ChangeStatusOptions) => {
        changeStatus(id, entityType, badgeStatus, message)
            .then((response: any) => {
                const res = responsePath === "data" ? response.data : response;
    
                const popUpTitle = res.status === ResponseStatus.ERROR
                    ? 'Error'
                    : (res.code === ResponseCode.UNPROCESSABLE_CONTENT
                        ? 'Warning'
                        : t(titleKey));
    
                const popUpDescription = (res.status === ResponseStatus.ERROR || res.code === ResponseCode.UNPROCESSABLE_CONTENT)
                    ? res.message
                    : t(descriptionKey);
    
                const popUpStatus: NotificationsStatusType = res.status === ResponseStatus.ERROR
                    ? 'error'
                    : (res.code === ResponseCode.UNPROCESSABLE_CONTENT
                        ? 'warning'
                        : 'confirm');
    
                const popUpAction: INotificationAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: () => dispatch(hideNotification()),
                };
    
                dispatch(showNotification(popUpAction));
                if (onSuccess) onSuccess();
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                loadData();
                dispatch(requestPristine());
                if (onFinally) onFinally();
            });
    };

    
    const approveTransporter = () => {
        handleChangeStatus({
            id: transportData?.id,
            entityType: EntityType.TRANSPORTER,
            badgeStatus: BadgeStatus.APPROVED,
            titleKey: "transporter.transporterData.approvalSuccessToast.approve.title",
            descriptionKey: "transporter.transporterData.approvalSuccessToast.approve.description",
        });
    };
    
    const rejectTransporter = (message: string) => {
        setViewRejectingTransporterModal(false);
        handleChangeStatus({
            id: transportData?.id,
            entityType: EntityType.TRANSPORTER,
            badgeStatus: BadgeStatus.NOTAPPROVED,
            message,
            titleKey: "transporter.transporterData.approvalSuccessToast.reject.title",
            descriptionKey: "transporter.transporterData.approvalSuccessToast.reject.description",
            responsePath: "data",
        });
    };
    
    const approveDelegation = (delegationId: string) => {
        handleChangeStatus({
            id: delegationId,
            entityType: EntityType.TRANSPORTERDELEGATION,
            badgeStatus: BadgeStatus.APPROVED,
            titleKey: "transporter.transporterData.approvalSuccessToast.approveDelegation.title",
            descriptionKey: "transporter.transporterData.approvalSuccessToast.approveDelegation.description",
            responsePath: "data",
        });
    };
    
    const rejectDelegation = (message: string) => {
        handleChangeStatus({
            id: rejectingDelegationId,
            entityType: EntityType.TRANSPORTERDELEGATION,
            badgeStatus: BadgeStatus.NOTAPPROVED,
            message,
            titleKey: "transporter.transporterData.approvalSuccessToast.rejectDelegation.title",
            descriptionKey: "transporter.transporterData.approvalSuccessToast.rejectDelegation.description",
            onFinally: () => setViewRejectionPopup(false),
        });
    };



    const enableDisableDelegation = (transporterId:string,delegationId:string,newStatus:boolean) => {
        dispatch(requestPending());
        enableDisableDelegationAPI(transporterId,delegationId, newStatus)
            .then((response) => {
                if (id) loadData(); 
                let popUpAction: INotificationAction;
                const popUpTitle:string = t(`transporter.transporterData.successToast.title_enableDisable`);
                const popUpDescription:string = newStatus?t(`transporter.transporterData.successToast.description_enable`):t(`transporter.transporterData.successToast.description_disable`);
                const popUpStatus:NotificationsStatusType = "confirm";
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
            
    }



    const deleteDelegation = (delegationId: string) => {
        //Gestione errori di business
        deleteDelegationAPI(delegationId, EntityType.TRANSPORTERDELEGATION)
            .then((response: any) => {
                //console.log(response);
                let popUpAction: INotificationAction;
                const popUpTitle:string = response.status===ResponseStatus.ERROR ? 'Error':(response.code===ResponseCode.UNPROCESSABLE_CONTENT? "Warning": "Delega eliminata correttamente" );
                const popUpDescription:string = response.status===ResponseStatus.ERROR||response.code===ResponseCode.UNPROCESSABLE_CONTENT?response.message:"La delega è stata eliminata correttamente in piattaforma";
                const popUpStatus:NotificationsStatusType = response.status===ResponseStatus.ERROR?"error":(response.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
                                
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    },
                };
                dispatch(showNotification(popUpAction));
                if(appUserRole===AppUserRole.CUSTOMER){
                    navigate(RoutePath.CONTRACTS_TRANSPORTATORS_INFO);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                loadData();
                dispatch(requestPristine());
            });
    };

    const tableColsDocuments = (() => {
        //return ["Tipologia documento", "Data fine validità", "", ""];
        //console.log(t("transporter.transporterData.fileTable.tableColumns", { ns: 'contract', returnObjects: true }) as string[]);
        return t("transporter.transporterData.fileTable.tableColumns", {
            ns: "contract",
            returnObjects: true,
        }) as string[];
    })();

    const getDocumentType = (type: string) => {
        let myType = "";
        if (type === DocumentType.SECURITY_TEMPLATE) {
            myType = "Security Protocol Template";
        }
        if (type === DocumentType.TRUCK_INSPECTION) {
            myType = t("transporter.transportData.truck_inspection");
        }
        if (type === DocumentType.ADR_DECLARATION) {
            myType = t("transporter.transportData.adr_declaration");
        }

        return myType;
    };

    const tableColsDelegations = (() => {
        return [
            t("transporter.transportData.tableColumnsDelegations.0"),
            t("transporter.transportData.tableColumnsDelegations.1"),
            "",
        ];

        //return t("transporter.transportData.tableColumnsDelegations", { ns: 'contract', returnObjects: true }) as string[];
    })();

    const getBadgeStatus = (status: BadgeStatus) => {
        let notificationStatus = "";

        if (
            status === BadgeStatus.APPROVED ||
            status === BadgeStatus.CREDITED
        ) {
            notificationStatus = "confirm";
        } else if (
            status === BadgeStatus.NOTAPPROVED ||
            status === BadgeStatus.NOT_CREDITED
        ) {
            notificationStatus = "error";
        } else if (
            status === BadgeStatus.TOAPPROVE ||
            status === BadgeStatus.TO_CREDIT
        ) {
            notificationStatus = "warning";
        }

        return notificationStatus;
    };

    const getDriverStatusBadge = (status: BadgeStatus) => {
        let notificationStatus: string = "";
        let statusMessage: string = "";

        if (status === BadgeStatus.APPROVED) {
            notificationStatus = "confirm";
            statusMessage = t("transporter.transporterData.badge.0");
        } else if (status === BadgeStatus.TOAPPROVE) {
            notificationStatus = "warning";
            statusMessage = t("transporter.transporterData.badge.2")/*+t('vehicle.vehicleData.statusBadgeMessage.5');*/;
        } else if (status === BadgeStatus.TO_CREDIT) {
            notificationStatus = "warning";
            statusMessage = t("transporter.transporterData.badge.5")/*+t('vehicle.vehicleData.statusBadgeMessage.4')*/;
        } else if (status === BadgeStatus.NOTAPPROVED) {
            notificationStatus = "error";
            statusMessage = t("transporter.transporterData.badge.1");
        } else if (status === BadgeStatus.NOT_CREDITED) {
            notificationStatus = "error";
            statusMessage = t("transporter.transporterData.badge.4");
        } else if (status === BadgeStatus.CREDITED) {
            notificationStatus = "confirm";
            statusMessage = t("transporter.transporterData.badge.3");
        } else if (status === BadgeStatus.EXPIRED) {
            notificationStatus = "error";
            statusMessage = "Expired document";
        }

        return (
            <div
                style={{
                    display: "flex",
                    width: "163px",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "46px",
                }}
            >
                <ds-notification-badge
                    notification-status={notificationStatus}
                    badge-variant="default"
                    badge-number="0"
                    badge-aria-label="Badge aria label"
                    is-small={true}
                    background-color=""
                ></ds-notification-badge>
                <span className="statusMessage">{statusMessage}</span>
            </div>
        );
    };
    const getTableRowsDocs = (): ITableRow[] => {
        let myRetArr: ITableRow[] = [];
        if (transportData?.documents) {
            for (let i = 0; i < transportData?.documents.length; i++) {
                if(i!==2){ //Escludo il terzo documento, è stato richiesto di rimuoverlo in corso d'opera
                    let tempObj: ITableRow = {
                        tableCells: [
                            { 
                                type: "text-badge", 
                                text: getDocumentType(transportData.documents[i].type),
                                badgeStatus: transportData.documents[i].expire === null ? "confirm" : moment.unix(transportData.documents[i].expire as number).isBefore(moment()) ? "error" : "confirm",
                            },
                            { 
                                type: "text", 
                                text: transportData.documents[i].expire !== null ?
                                parseDateForDS(
                                    moment
                                        .unix(transportData.documents[i].expire as number) 
                                        .format(DATE_FORMAT),
                                    IParseDateFormatType.DATE_FORMAT1
                                ) : ""
                            },
                            { 
                                type: "text", 
                                text: transportData.documents[i].lastUpdate
                            },
                            { 
                                type: "text", 
                                text: transportData.documents[i].lastUpdateUser
                            },
                            /*{
                                type : "link",
                                text : t("general.buttons.modify", {ns: "app",}),
                                linkAriaLabel : t("general.buttons.modify", {ns: "app",}),
                                disabled: appUserProfile?.editEntityPolicy.includes(EntityType.TRANSPORTER) ? false : true,
                                isRouterLink:true
                            }*/            
                        ],
                        //rightIcon: "icon-download",
                        rightIconMenu:true,
                        "rightIconMenuData":[
                            {
                                "actionLabel": t("general.buttons.modify",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.modify",{ ns: "app" }), //EDIT
                                "actionDisabled": appUserProfile?.editEntityPolicy.includes(EntityType.TRANSPORTER) ? false : true,
                            },
                            {
                                "actionLabel": t("general.buttons.download_short",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.download_short",{ ns: "app" }), //DOWNLOAD
                                "actionDisabled": false,
                            }
                        ]
                    };
                    myRetArr.push(tempObj);
                }                
            }
        }
        return myRetArr;
    };
    const myTableConfigDocs: ITableConfig = {
                            ...getDSTableSharedElements(),
                            tableHeader: {
                                
                                tableCellsHeader: [
                                    getTableCellsHeaderSimple(t("transporter.transporterData.fileTable.tableColumns.0", {ns: "contract"}) as string,"col1","25%","left"),
                                    getTableCellsHeaderSimple(t("transporter.transporterData.fileTable.tableColumns.1", {ns: "contract"}) as string,"col2","25%","left"),
                                    getTableCellsHeaderSimple(t("drivers.driverData.fileTable.tableColumns.2", { ns: 'contract' }) as string,"col3","25%","left"),
                                    getTableCellsHeaderSimple(t("drivers.driverData.fileTable.tableColumns.3", { ns: 'contract' }) as string,"col4","25%","left")
                                                                 
                                ],
                                hasSearchBox: true,
                            },
                            tableRows: getTableRowsDocs()
    };
    const getTableRowsDelegations = (): ITableRow[] => {
        let myRetArr: ITableRow[] = [];
        let test : ITableCell
        if (transportData?.delegations) {
            for (let i = 0; i < transportData?.delegations.length; i++) {
                    let tempObj: ITableRow = {
                        tableCells: [
                            { 
                                type: "text-badge", 
                                text: transportData.delegations[i].businessName,
                                badgeStatus: transportData.delegations[i].document.status===BadgeStatus.EXPIRED ? "error" : 
                                transportData.delegations[i].document.status===BadgeStatus.TOAPPROVE ? "warning" : 
                                transportData.delegations[i].document.status===BadgeStatus.APPROVED ? "confirm" : "error",
                            },
                            { 
                                type: "text", 
                                text: transportData.delegations[i].document.expire !== null ? parseDateForDS(
                                    moment
                                        .unix(transportData.delegations[i].document.expire as number)
                                        .format(DATE_FORMAT),
                                    IParseDateFormatType.DATE_FORMAT1
                                ) : ""
                            },
                            { 
                                type: "text-badge", 
                                text: "",
                                badgeStatus: transportData.delegations[i].delegationAbilitation ? (transportData.delegations[i].delegationAbilitation===true?"confirm":"error") : "error"
                            },
                            { 
                                type: "text", 
                                text: transportData.delegations[i].lastUpdate
                            },
                            { 
                                type: "text", 
                                text: transportData.delegations[i].lastUpdateUser
                            },
                        ],
                        //rightIcon: "icon-download",
                        "rightIconMenu": true,
                        "rightIconMenuData": (transportData.status === BadgeStatus.APPROVED && transportData.delegations[i].document.status ===BadgeStatus.TOAPPROVE) ?
                        [
                            {
                                "actionLabel": t("general.buttons.approve",{ ns: "app", what: "" }), //APPROVE
                                "actionAriaLabel": t("general.buttons.approve",{ ns: "app", what: "" }),
                                "actionDisabled": false,
                                //"actionIcon": "icon-share"
                            },
                            {
                                "actionLabel": t("general.buttons.reject",{ ns: "app", what: "" }), //REJECT/NON APPROVA
                                "actionAriaLabel": t("general.buttons.reject",{ ns: "app", what: "" }),
                                "actionDisabled": false,
                            },
                            {
                                "actionLabel": t("general.buttons.modify",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.modify",{ ns: "app" }), //EDIT
                                "actionDisabled": !appUserProfile?.editEntityPolicy.includes(EntityType.TRANSPORTER),
                            },
                            {
                                "actionLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }),
                                "actionAriaLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }), // DELETE
                                "actionDisabled": false,
                            },
                            {
                                "actionLabel": t("general.buttons.download_short",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.download_short",{ ns: "app" }), //DOWNLOAD
                                "actionDisabled": false,
                            },
                            {
                                "actionLabel": t("general.buttons.disable_enable",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.disable_enable",{ ns: "app" }), //ABILITA/DISABILITA DELEGA
                                "actionDisabled": !appUserProfile?.editEntityPolicy.includes(EntityType.TRANSPORTERDELEGATION),
                            }
                        ]
                        :
                        [
                            {
                                "actionLabel": t("general.buttons.modify",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.modify",{ ns: "app" }), //EDIT
                                "actionDisabled": !appUserProfile?.editEntityPolicy.includes(EntityType.TRANSPORTER),
                            },
                            {
                                "actionLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }),
                                "actionAriaLabel": t("general.buttons.removeElement",{ ns: "app", what: "" }), // DELETE
                                "actionDisabled": false,
                            },
                            {
                                "actionLabel": t("general.buttons.download_short",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.download_short",{ ns: "app" }), //DOWNLOAD
                                "actionDisabled": false,
                            },
                            {
                                "actionLabel": t("general.buttons.disable_enable",{ ns: "app" }),
                                "actionAriaLabel": t("general.buttons.disable_enable",{ ns: "app" }), //ABILITA/DISABILITA DELEGA
                                "actionDisabled": !appUserProfile?.editEntityPolicy.includes(EntityType.TRANSPORTERDELEGATION),
                            }
                        ]
                    };
                    myRetArr.push(tempObj);           
            }
        }
        return myRetArr;
    };
    const myTableConfigDelegations: ITableConfig = {
        ...getDSTableSharedElements(),
        tableHeader: {
            tableCellsHeader: [
                getTableCellsHeaderSimple(t("transporter.transportData.tableColumnsDelegations.0") as string,"col1","20%","left"),
                getTableCellsHeaderSimple(t("transporter.transportData.tableColumnsDelegations.1") as string,"col2","20%","left"),
                getTableCellsHeaderSimple(t("transporter.transportData.tableColumnsDelegations.3"),"col3","20%","left"),
                getTableCellsHeaderSimple(t("drivers.driverData.fileTable.tableColumns.2", { ns: 'contract' }) as string,"col4","20%","left"),
                getTableCellsHeaderSimple(t("drivers.driverData.fileTable.tableColumns.3", { ns: 'contract' }) as string,"col5","20%","left")
            ],
            hasSearchBox: true,
        },
        tableRows: getTableRowsDelegations()
};


    return (
        <div style={{ fontFamily: "Lato, Lato-local, sans-serif" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "column",
                    }}
                >
                    <p className="pageTitle" style={{ marginBottom: "16px" }}>
                        {/*Nome dell'azienda trasportatrice delegata*/}
                        {t("transporter.transporterData.title")}
                    </p>
                </div>
                <div>{getDriverStatusBadge(transportData?.status)}</div>
            </div>
            <Row>
                <Col>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                        }}
                    >
                        {appUserProfile?.deleteEntityPolicy.includes(
                            EntityType.TRANSPORTER
                        ) && (
                            <div className="column" style={{ float: "left" }}>
                                <Textlink
                                    textlinkText={t(
                                        "transporter.transportData.deleteButton"
                                    )}
                                    textlinkTextSize="SMALL"
                                    isRouterLink={true}
                                    onClickLink={() => {
                                        setShowConfirm(true);
                                    }}
                                />
                            </div>
                        )}

                        {transportData?.status === BadgeStatus.TOAPPROVE &&
                            appUserProfile?.approveEntityPolicy.includes(
                                EntityType.TRANSPORTER
                            ) && (
                                <div style={{ display: "flex", gap: "16px", marginTop:'16px' }}>
                                    <>
                                        <Button
                                            buttonType="button"
                                            buttonUIVariant="primary"
                                            buttonSize="medium"
                                            buttonLabel={t(
                                                "transporter.transportData.ApproveButton"
                                            )} /*'Approva trasportatore'*/
                                            buttonIcon=""
                                            isDisabled={false}
                                            buttonAriaLabel="accept transportator button"
                                            onClick={() => {
                                                approveTransporter();
                                            }}
                                        ></Button>

                                        <Button
                                            buttonType="button"
                                            buttonUIVariant="secondary"
                                            buttonSize="medium"
                                            buttonLabel={t(
                                                "transporter.transportData.rejectButton"
                                            )} /*'Rifiuta trasportatore'*/
                                            buttonIcon=""
                                            isDisabled={false}
                                            buttonAriaLabel="decline transportator button"
                                            onClick={() => {
                                                setViewRejectingTransporterModal(
                                                    true
                                                );
                                            }}
                                        ></Button>
                                    </>
                                </div>
                            )}
                    </div>
                </Col>
            </Row>
            {transportData && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        marginBottom: "24px",
                        marginTop: "16px",
                    }}
                >
                    {/*<ds-avatar avatar-type="icon" avatar-size="medium"></ds-avatar>*/}
                    <div
                        style={{
                            backgroundColor: "var(--interaction-active)",
                            width: "64px",
                            height: "64px",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img
                            alt=""
                            src={transportIcon}
                            style={{ width: "32px", height: "32px" }}
                        />
                    </div>
                    <div style={{ height: "fit-content", marginLeft: "10px" }}>
                        <div>
                            <span className="avatarText">
                                {/*Nome*/}
                                {t("transporter.transporterData.avatar.label1")}
                            </span>
                            <span className="avatarTitle">
                                {" "}
                                {transportData.businessName}
                            </span>
                        </div>
                        <div>
                            <span className="avatarText">
                                {/*Ragione sociale*/}
                                {t("transporter.transporterData.avatar.label2")}
                            </span>
                            <span className="avatarTitle">
                                {" "}
                                {transportData.businessSecondName}
                            </span>
                        </div>
                        <div>
                            <span className="avatarText">
                                {/*Codice fiscale / VAT*/}
                                {t("transporter.transporterData.avatar.label3")}
                            </span>
                            <span className="avatarTitle">
                                {" "}
                                {transportData.vat}
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div>
                {transportData && <TransportInfo formData={transportData} />}
            </div>
            <div style={{ background: "" }}>
                <div style={{ float: "right" }}>
                    <Button
                        buttonType="button"
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t("general.buttons.download", {
                            ns: "app",
                        })} //'Scarica informazioni'
                        buttonIcon=""
                        isDisabled={false}
                        buttonAriaLabel="download info button"
                        onClick={downloadTranportertInfo}
                    ></Button>
                </div>
                {appUserProfile?.editEntityPolicy.includes(
                    EntityType.TRANSPORTER
                ) && (
                    <div
                        style={{
                            float: "right",
                            marginRight: "15px",
                        }}
                    >
                        <Button
                            buttonType="button"
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonLabel={t("general.buttons.edit", {
                                ns: "app",
                            })} //'Modifica informazioni'
                            buttonIcon=""
                            isDisabled={false}
                            buttonAriaLabel="modify info button"
                            onClick={() => {
                                navigate(
                                    RoutePath.CONTRACTS_EDIT_TRANSPORT +
                                        "/" +
                                        id
                                );
                            }}
                        ></Button>
                    </div>
                )}
            </div>
            <div style={{ marginTop: "64px" }}>
                <p
                    style={{
                        fontWeight: "bold",
                        fontSize: "90%",
                        color:
                            layoutMode === DsLayout.DARK_MODE
                                ? "white"
                                : "#0e2852",
                    }}
                >
                    {t("transporter.transporterData.fileTable.title")}
                </p>{" "}
                {/*documenti*/}
                <div className="listTableContainer" style={{ background: "" }}>
                    {transportData && (
                        <>
                            {/*<SimpleTable
                                columns={tableColsDocuments}
                                rows={tableRowsDocuments}
                                tableType={SimpleTableType.DOCUMENTS}
                                id={"simpleTable_1"}
                            />*/}
                            {
                                <Table 
                                    tableConfig={myTableConfigDocs} 
                                    style={{}}
                                    onColumnSorting={(event:Event)=>{
                                        //console.log(event)
                                    }}
                                    onInputSearchBarChange={(event:Event)=>{
                                        console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                    }}
                                    onClickRightAction={(event:Event)=>{
                                        
                                    }}
                                    onButtonItemCellClick={(event:Event)=>{
                                        
                                    }}
                                    onTextLinkCellClick={(event:Event)=>{
                                        
                                    }}
                                    onClickKebabAction1={(event:Event)=>{ 
                                        navigate(
                                            RoutePath.CONTRACTS_EDIT_DOCUMENT +
                                                "?entityId=" +
                                                id +
                                                "&entityType=" +
                                                EntityType.TRANSPORTER +
                                                "&documentType=" +
                                                transportData?.documents[(event as CustomEvent).detail.row].type
                                        );
                                    }}   
                                    onClickKebabAction2={(event:Event)=>{ 
                                        downloadTransporterDocument(transportData?.documents[(event as CustomEvent).detail.row].type as DocumentType);
                                    }}                                 
                                />
                            }
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    marginTop: "24px",
                                }}
                            >
                                {getBadgeDocuments(BadgeStatus.TOAPPROVE, true)}
                                <span className="legendaLabel--contract">
                                    {t(
                                        "transporter.transporterData.fileTable.tableLegend.0"
                                    )}
                                </span>
                                {getBadgeDocuments(BadgeStatus.EXPIRED, true)}
                                <span className="legendaLabel--contract">
                                    {t(
                                        "transporter.transporterData.fileTable.tableLegend.1"
                                    )}
                                </span>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div style={{ border: "1px solid grey", marginTop: "15px" }}></div>
            <p
                style={{
                    fontWeight: "bold",
                    fontSize: "90%",
                    color:
                        layoutMode === DsLayout.DARK_MODE ? "white" : "#0e2852",
                }}
            >
                {t("transporter.transporterData.delegationTable.title")}
            </p>{" "}
            {/*Atti di delega del cliente*/}
            <div className="listTableContainer" style={{ background: "" }}>
                {transportData.delegations.length !== 0 ? (
                    <>
                        {/*<SimpleTable
                            columns={tableColsDelegations}
                            rows={tableRowsDelegations}
                            tableType={SimpleTableType.DELEGATIONS}
                            id={"simpleTable_2"}
                        />*/}
                        {
                            <Table 
                                tableConfig={myTableConfigDelegations} 
                                style={{}}
                                onColumnSorting={(event:Event)=>{
                                    //console.log(event)
                                }}
                                onInputSearchBarChange={(event:Event)=>{
                                    console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                }}
                                onClickRightAction={(event:Event)=>{
                                    console.log(event)
                                    //navigate(contractList[(event as CustomEvent).detail.row].contractId)
                                }}
                                onButtonItemCellClick={(event:Event)=>{
                                    console.log(event)
                                }}

                                onClickKebabAction1={(event:Event)=>{ //APPROVE o edit
                                    console.log(transportData?.delegations[(event as CustomEvent).detail.row])
                                    //(transportData.status === BadgeStatus.APPROVED && transportData.delegations[i].document.status ===BadgeStatus.TOAPPROVE)
                                    if(transportData?.status === BadgeStatus.APPROVED && transportData?.delegations[(event as CustomEvent).detail.row].document.status===BadgeStatus.TOAPPROVE){ //se è in pending devo fare approve, altrimenti il kebab menu ha solo 3 elementi e quindi corrisponde all'edit
                                        approveDelegation(transportData?.delegations[(event as CustomEvent).detail.row].delegationId)
                                    }else{
                                        navigate(
                                            RoutePath.CONTRACTS_EDIT_DOCUMENT +
                                                "?entityId=" +
                                                transportData?.delegations[(event as CustomEvent).detail.row].delegationId +
                                                "&entityType=" +
                                                EntityType.TRANSPORTERDELEGATION +
                                                "&documentType=" +
                                                transportData?.delegations[(event as CustomEvent).detail.row].document.type +
                                                "&transporterId=" +
                                                transportData.id
                                        );  
                                    }
                                }}
                                onClickKebabAction2={(event:Event)=>{ //REJECT o delete
                                    if(transportData?.status === BadgeStatus.APPROVED && transportData?.delegations[(event as CustomEvent).detail.row].document.status===BadgeStatus.TOAPPROVE){ 
                                        setViewRejectionPopup(true);
                                        setRejectingDelegationId(
                                            transportData?.delegations[(event as CustomEvent).detail.row].delegationId
                                        );
                                    }else{
                                        deleteDelegation(transportData?.delegations[(event as CustomEvent).detail.row].delegationId);
                                    }
                                }}
                                onClickKebabAction3={(event:Event)=>{ //EDIT o download
                                    if(transportData?.status === BadgeStatus.APPROVED && transportData?.delegations[(event as CustomEvent).detail.row].document.status===BadgeStatus.TOAPPROVE){ 
                                        navigate(
                                            RoutePath.CONTRACTS_EDIT_DOCUMENT +
                                                "?entityId=" +
                                                transportData?.delegations[(event as CustomEvent).detail.row].delegationId +
                                                "&entityType=" +
                                                EntityType.TRANSPORTERDELEGATION +
                                                "&documentType=" +
                                                transportData?.delegations[(event as CustomEvent).detail.row].document.type +
                                                "&transporterId=" +
                                                transportData.id
                                        );
                                    }else{
                                        downloadTransporterDelegation(
                                            transportData?.delegations[(event as CustomEvent).detail.row].delegationId,
                                            DocumentType.DELEGATION
                                        );
                                    }
                                }}
                                onClickKebabAction4={(event:Event)=>{ //DELETE o ENABLE DISABLE
                                    if((transportData.status === BadgeStatus.APPROVED && transportData.delegations[(event as CustomEvent).detail.row].document.status ===BadgeStatus.TOAPPROVE)){
                                        deleteDelegation(transportData?.delegations[(event as CustomEvent).detail.row].delegationId);
                                    }else{
                                        enableDisableDelegation(
                                            transportData?.delegations[(event as CustomEvent).detail.row].transporterId,
                                            transportData?.delegations[(event as CustomEvent).detail.row].delegationId,
                                            !transportData?.delegations[(event as CustomEvent).detail.row].delegationAbilitation //l'opposto
                                    );
                                    }
                                   
                                }}
                                onClickKebabAction5={(event:Event)=>{ //DOWNLOAD
                                    downloadTransporterDelegation(
                                        transportData?.delegations[(event as CustomEvent).detail.row].delegationId,
                                        DocumentType.DELEGATION
                                    );
                                }}
                                onClickKebabAction6={(event:Event)=>{ //ENABLE DISABLE
                                    enableDisableDelegation(
                                        transportData?.delegations[(event as CustomEvent).detail.row].transporterId,
                                        transportData?.delegations[(event as CustomEvent).detail.row].delegationId,
                                        !transportData?.delegations[(event as CustomEvent).detail.row].delegationAbilitation
                                    );
                                }}
                            />
                        }
                        {getDelegationLegend(true)}
                    </>
                ) : (
                    <p
                        style={{
                            color:
                                layoutMode === DsLayout.DARK_MODE
                                    ? "white"
                                    : "black",
                        }}
                    >
                        {t("transporter.transportData.noDelegationFound")}
                        {/*Non sono presenti deleghe a sistema*/}
                    </p>
                )}
            </div>
            <div style={{ border: "1px solid grey", marginTop: "15px" }}></div>
            {/** Delete confirm */}
            {showConfirm && (
                <ConfirmPopUp
                    title={t("transporter.transporterData.deleteConfirm.title")} //"Sei sicuro di voler eliminare il trasportatore?"
                    description={t(
                        "transporter.transporterData.deleteConfirm.description"
                    )} //"L’azione è irreversibile e dovrai inserire ex novo tutte le informazioni sul trasportatore."
                    onClose={() => {
                        setShowConfirm(false);
                    }}
                    onConfirm={() => {
                        setShowConfirm(false);
                        deleteTransporter();
                    }}
                />
            )}
            {viewRejectingTransporterModal === true && (
                <>
                    <DialogMessage
                        title={t(
                            "transporter.transporterData.rejectDialog.transporter.title"
                        )} //{transporterRejectionTitle}
                        subtitle={t(
                            "transporter.transporterData.rejectDialog.transporter.subTitle"
                        )} //{transporterRejectionSubtitle}
                        textareaLabel={t(
                            "drivers.driverData.rejectDialog.textareaLabel"
                        )}
                        textAreaPlaceholder={t(
                            "drivers.driverData.rejectDialog.txtAreaPlaceholder"
                        )}
                        textareaDescription={t(
                            "drivers.driverData.rejectDialog.textareaDescription"
                        )}
                        submitButtonLabel={t(
                            "drivers.driverData.rejectDialog.submitButtonLabel"
                        )}
                        icon={""}
                        type={EntityType.TRANSPORTER}
                        onClose={() => setViewRejectingTransporterModal(false)}
                        onClick={rejectTransporter}
                    />
                </>
            )}
            {viewRejectionPopup && (
                <>
                    <DialogMessage
                        title={t(
                            "transporter.transporterData.rejectDialog.delegation.title"
                        )} //{delegationRejectionTitle}
                        subtitle={t(
                            "transporter.transporterData.rejectDialog.delegation.subTitle"
                        )} //{delegationRejectionSubtitle}
                        textareaLabel={t(
                            "drivers.driverData.rejectDialog.textareaLabel"
                        )}
                        textAreaPlaceholder={t(
                            "drivers.driverData.rejectDialog.txtAreaPlaceholder"
                        )}
                        textareaDescription={t(
                            "drivers.driverData.rejectDialog.textareaDescription"
                        )}
                        submitButtonLabel={t(
                            "drivers.driverData.rejectDialog.submitButtonLabel"
                        )}
                        icon={""}
                        type={EntityType.TRANSPORTERDELEGATION}
                        onClose={() => setViewRejectionPopup(false)}
                        onClick={rejectDelegation}
                    />
                </>
            )}
        </div>
    );
};
export default TransportData;
